"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetCurrentTopLeaderboardRankingsResponseToJSON = exports.GetCurrentTopLeaderboardRankingsResponseFromJSONTyped = exports.GetCurrentTopLeaderboardRankingsResponseFromJSON = void 0;
var _1 = require("./");
function GetCurrentTopLeaderboardRankingsResponseFromJSON(json) {
    return GetCurrentTopLeaderboardRankingsResponseFromJSONTyped(json, false);
}
exports.GetCurrentTopLeaderboardRankingsResponseFromJSON = GetCurrentTopLeaderboardRankingsResponseFromJSON;
function GetCurrentTopLeaderboardRankingsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'leaderboardRankings': (json['leaderboardRankings'].map(_1.TopLeaderboardCommunityFromJSON)),
    };
}
exports.GetCurrentTopLeaderboardRankingsResponseFromJSONTyped = GetCurrentTopLeaderboardRankingsResponseFromJSONTyped;
function GetCurrentTopLeaderboardRankingsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'leaderboardRankings': (value.leaderboardRankings.map(_1.TopLeaderboardCommunityToJSON)),
    };
}
exports.GetCurrentTopLeaderboardRankingsResponseToJSON = GetCurrentTopLeaderboardRankingsResponseToJSON;
